import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Signup() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    businessName: "",
    phone: "",
  });
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSignup = async () => {
    if (!form.name || !form.email || !form.password || !form.businessName || !form.phone) {
      setMessage("Please fill in all fields ❌");
      return;
    }

    try {
      const res = await fetch("https://reflex-backend.alfaoir1.workers.dev/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const data = await res.json();

      if (data.success) {
        setMessage("Account created ✅");
        setTimeout(() => navigate("/login"), 1500);
      } else {
        setMessage(data.error || "Signup failed ❌");
      }
    } catch (err) {
      setMessage("Server error ❌");
    }
  };

  return (
    <div style={{ maxWidth: "400px", margin: "60px auto", padding: "20px", fontFamily: "sans-serif" }}>
      <h2>Create Account</h2>

      <input name="name" placeholder="Full Name" value={form.name} onChange={handleChange}
        style={{ width: "100%", padding: "10px", marginBottom: "10px", borderRadius: "6px", border: "1px solid #ccc" }} />

      <input name="email" placeholder="Email" value={form.email} onChange={handleChange}
        style={{ width: "100%", padding: "10px", marginBottom: "10px", borderRadius: "6px", border: "1px solid #ccc" }} />

      <input name="password" type="password" placeholder="Password" value={form.password} onChange={handleChange}
        style={{ width: "100%", padding: "10px", marginBottom: "10px", borderRadius: "6px", border: "1px solid #ccc" }} />

      <input name="businessName" placeholder="Business Name" value={form.businessName} onChange={handleChange}
        style={{ width: "100%", padding: "10px", marginBottom: "10px", borderRadius: "6px", border: "1px solid #ccc" }} />

      <input name="phone" placeholder="Phone Number" value={form.phone} onChange={handleChange}
        style={{ width: "100%", padding: "10px", marginBottom: "10px", borderRadius: "6px", border: "1px solid #ccc" }} />

      <button onClick={handleSignup}
        style={{ width: "100%", padding: "12px", background: "#007bff", color: "white", border: "none", borderRadius: "6px", cursor: "pointer", fontSize: "16px" }}>
        Create Account
      </button>

      <p style={{ color: "red", marginTop: "10px" }}>{message}</p>
      <p style={{ marginTop: "10px" }}>Already have an account? <a href="/login">Login</a></p>
    </div>
  );
}